import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { zustandModeratorAppStorage } from './mmkvAppPersistence';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

type AppSettings = {
  moderationAppLanguage: string;
  setModerationAppLanguage: (languageKey: string) => void;
  lastExecutionTime: string;
  setLastExecutionTime: (lastExecutionTime: string) => void;
  setModerationAppLanguageLabel: (languageLabel: string) => void;
  moderationAppLanguageLabel: string;
};

export const useAppPersistenceModerationStore = create<AppSettings>()(
  devtools(
    persist(
      (set, get) => ({
        moderationAppLanguage: get()?.moderationAppLanguage ?? 'hi',
        setModerationAppLanguage: (languageKey) =>
          set(() => ({ moderationAppLanguage: languageKey })),
        lastExecutionTime: get()?.lastExecutionTime,
        setLastExecutionTime: (time) => set(() => ({ lastExecutionTime: time })),
        setModerationAppLanguageLabel: (languageLabel) =>
          set(() => ({ moderationAppLanguageLabel: languageLabel })),
        moderationAppLanguageLabel: get()?.moderationAppLanguageLabel ?? 'Hindi',
      }),
      {
        name: MMKVStoreKeyMap.moderatorAppSettings,
        storage: createJSONStorage(() => zustandModeratorAppStorage),
      }
    )
  )
);
